const BADGE = {
  boot: 'background:#4f46e5;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
  api: 'background:#0891b2;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
  ok: 'background:#059669;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
  err: 'background:#dc2626;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
  evt: 'background:#ea580c;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
  page: 'background:#7c3aed;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
  auth: 'background:#0a0b14;color:#fff;padding:2px 6px;border-radius:4px;font-weight:700',
};

export function dbg(kind, label, ...rest) {
  console.log(`%c${kind.toUpperCase()}%c ${label}`, BADGE[kind], 'color:inherit', ...rest);
}

export function dbgErr(kind, label, ...rest) {
  console.error(`%c${kind.toUpperCase()}%c ${label}`, BADGE.err, 'color:inherit', ...rest);
  emitAppError(label, rest);
}

export function emitAppError(label, detail) {
  try {
    window.dispatchEvent(
      new CustomEvent('app-error', { detail: { label: String(label), detail } }),
    );
  } catch {}
}

let installed = false;
export function installGlobalErrorLogging() {
  if (installed) return;
  installed = true;

  window.addEventListener('error', (ev) => {
    const label = `uncaught: ${ev.message}`;
    dbgErr(
      'err',
      label,
      { file: ev.filename, line: ev.lineno, col: ev.colno, error: ev.error },
    );
  });

  window.addEventListener('unhandledrejection', (ev) => {
    const reason = ev.reason;
    const msg =
      reason && typeof reason === 'object'
        ? reason.message || JSON.stringify(reason).slice(0, 300)
        : String(reason);
    dbgErr('err', `unhandled promise rejection: ${msg}`, reason);
  });

  const origFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input.url;
    const method = (init?.method || input?.method || 'GET').toUpperCase();
    const t0 = performance.now();
    try {
      const res = await origFetch(input, init);
      const ms = Math.round(performance.now() - t0);
      if (res.ok) {
        dbg('ok', `${method} ${url} → ${res.status} (${ms}ms)`);
      } else {
        dbgErr('err', `${method} ${url} → ${res.status} (${ms}ms)`);
      }
      return res;
    } catch (e) {
      const ms = Math.round(performance.now() - t0);
      dbgErr('err', `${method} ${url} — network failure (${ms}ms)`, e);
      throw e;
    }
  };
}

export function bootBanner(info) {
  console.warn(
    '%c★ Dissertation Island — debug mode loaded',
    'font-size:14px;color:#4f46e5;font-weight:800;letter-spacing:0.04em',
  );
  console.table(info);
  console.warn(
    '%cIf you can read this, console logging is working. Look for colored badges: BOOT / API / OK / ERR / EVT / PAGE / AUTH.',
    'color:#6b7280;font-style:italic',
  );
}
